import { Measure } from 'services/model/model.service';

export const MARKDOWN_VS_CATEGORY_CODE = 'markdownVsCategory';
export const REFERENCE_MARKDOWN_VALUE = 'referenceMarkdownValue';
export const REFERENCE_ORIGINAL_MERCHANDISE_VALUE = 'referenceOriginalMerchandiseValue';

export function getMarkdownVsCategoryValue(slsMkdRate: Measure, values?: Record<string, number>) {
  const referenceOriginalMerchandiseValue = values?.[REFERENCE_ORIGINAL_MERCHANDISE_VALUE] ?? 0;

  if (referenceOriginalMerchandiseValue === 0) {
    return 0;
  }

  return getReferenceMarkdownRate(values) - slsMkdRate.getValue(values);
}

export function getReferenceMarkdownRate(values?: Record<string, number>) {
  const referenceOriginalMerchandiseValue = values?.[REFERENCE_ORIGINAL_MERCHANDISE_VALUE] ?? 0;

  if (referenceOriginalMerchandiseValue === 0) {
    return 0;
  }

  return (values?.[REFERENCE_MARKDOWN_VALUE] ?? 0) / referenceOriginalMerchandiseValue;
}

export function toMarkdownVsCategoryMeasure(slsMkdRate: Measure, labelId = 'price.kpi.markdownVsCategory'): Measure {
  return {
    ...slsMkdRate,
    code: MARKDOWN_VS_CATEGORY_CODE,
    labelId,
    getValue: (values?: Record<string, number>) => getMarkdownVsCategoryValue(slsMkdRate, values),
  };
}
